


















































































































































































import { Component, Mixins } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { Actions, Mutations } from '@/ts/store/Constants';
import ConfirmPopup from '@/components/Admin/Panels/ConfirmPopup.vue';
import InputFieldMethods from '@/mixins/InputFieldMethods.vue';
import DateMethods from '@/mixins/DateMethods.vue';
import MultiSelect from 'vue-multiselect';
import NotifyMethods from '@/mixins/NotifyMethods.vue';
import ProjectsData from '@/ts/ProjectsData';
import BuildingData from '@/ts/BuildingData';
import PropertyData from '@/ts/PropertyData';

@Component({
    components: {
        ConfirmPopup,
        MultiSelect,
    },
    computed: {
        ...mapGetters({
            groupingTypes: 'Groupings/getGroupingTypes',
            confirmPopupVisibility: 'ConfirmPopup/getConfirmPopupVisibility',
        }),
    },
})
export default class AddGrouping extends Mixins(InputFieldMethods, DateMethods, NotifyMethods) {
    public groupingName: any = '';
    public groupingType: any = '';
    public groupingSelectedProjects: any[] = [];
    public groupingSelectedUnitGroups: any[] = [];
    public groupingSelectedUnits: any = [];

    constructor() {
        super();
    }

    get projects(): ProjectsData[] {
        return this.$store.getters['Projects/allProjects'];
    }

    get buildings(): BuildingData[] {
        return !this.groupingSelectedProjects.length
            ? []
            : this.$store.getters['Buildings/projectsBuildings'](this.groupingSelectedProjects.map((project) => project.id));
    }

    get properties(): PropertyData[] {
        if (this.groupingSelectedUnitGroups.length) {
            return this.$store.getters['Properties/buildingsProperties'](this.groupingSelectedUnitGroups.map((building) => building.id));
        }

        if (this.groupingSelectedProjects.length) {
            return this.$store.getters['Properties/projectsProperties'](this.groupingSelectedProjects.map((project) => project.id));
        }

        return [];
    }

    public resetGroupingUnitGroups() {
        this.groupingSelectedUnitGroups = [];
    }

    public resetGroupingUnits() {
        for (const checkbox of document.getElementsByTagName('input')) {
            if (checkbox.classList.contains('unit-check-item')) {
                checkbox.checked = false;
            }
        }

        this.groupingSelectedUnits = [];
    }

    public selectProject() {
        this.resetGroupingUnitGroups();
        this.resetGroupingUnits();
    }

    public selectBuildings() {
        this.resetGroupingUnits();
    }

    public selectProperty(ev: any, unitId: number) {
        if (ev.srcElement.checked) {
            this.groupingSelectedUnits.push(unitId);
        } else {
            this.groupingSelectedUnits = this.groupingSelectedUnits.filter((unit: any) => {
                return unit !== unitId;
            });
        }
    }

    public checkOrUncheckAllUnits(ev: any) {
        for (const checkbox of document.getElementsByTagName('input')) {
            if (checkbox.classList.contains('unit-check-item')) {
                checkbox.checked = ev.srcElement.checked;
            }
        }

        this.groupingSelectedUnits = ev.srcElement.checked ? this.properties.map((unit: any) => unit.id) : [];
    }

    public cancel() {
        this.$router.push({ name: 'admin-groupings' });
    }

    public saveGroupings() {
        this.$validator.validate().then((valid) => {
            if (valid) {
                if (!this.groupingSelectedUnits.length) {
                    return this.notify('please_select_at_least_one_unit', 'warning');
                }

                const projectIds   = this.groupingSelectedProjects.map((project: any) => project.id);
                const unitGroupIds = this.groupingSelectedUnitGroups.map((unitGroup: any) => unitGroup.id);
                const unitIds      = this.groupingSelectedUnits;

                this.$store.dispatch(Actions.ADD_NEW_GROUPING, {
                    groupingName: this.groupingName,
                    groupingType: this.groupingType,
                    unitIds,
                });
            }
        });
    }

    public mounted() {
        this.$store.dispatch(Actions.FETCH_GROUPING_TYPES);
    }
}
